import { toPartialGridItemProduct } from "../converters"
import { PRODUCTS_INDEX_NAME } from "../services/client"
import { AlgoliaProductVariant } from "../types/doc"
import { getRecommendClient } from "../api/recommend"
import { toAlgoliaFilter } from "../api/filters"
import { PartialGridItemProduct } from "../../../ui/organisms/Product/ProductGridItem/types"

export interface FetchAlgoliaBoughtTogetherInput {
  sourceEan: string
  excludeProductIds: string[]
  brandCodes?: string[]
  maxItems?: number
}

export const fetchAlgoliaBoughtTogetherItems = async (
  input: FetchAlgoliaBoughtTogetherInput
): Promise<PartialGridItemProduct[]> => {
  try {
    const results = await getRecommendClient().getFrequentlyBoughtTogether([
      {
        indexName: PRODUCTS_INDEX_NAME,
        objectID: input.sourceEan,
        maxRecommendations: input.maxItems,
        queryParameters: {
          filters: toAlgoliaFilter(
            {
              excludeProductIds: input.excludeProductIds,
              brandCodes: input.brandCodes,
            },
            new Date()
          ),
        },
      },
    ])
    return results.results[0].hits.map((x: AlgoliaProductVariant) =>
      toPartialGridItemProduct(x)
    )
  } catch (e) {
    console.error("Error searching bought together")
    return []
  }
}
